import React from "react"
import "./index.scss"

const NoResults = () => <div className="no-results-container">No Results</div>
export default NoResults
